<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <tanitimMail ref="tanitimdialog" :servisTipi="2"></tanitimMail>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> Transfer Fiyat Listesi</v-toolbar-title>
            <v-spacer></v-spacer>
             <v-tooltip bottom>
                          <v-btn  slot="activator" @click="tedarikcidialogac()" flat> <v-icon left dark>add_box</v-icon> <span
                              class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Supplier-Info') }}   </span>
                            </span>
                           
                          </v-btn>
                         
                        </v-tooltip>
          </v-toolbar>
        </v-flex>
         <v-dialog v-model="dialogtedarikciGuncelle" persi persistent max-width="800">
<v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text">{{ 'Tedarikçi Düzenle' }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
         
 <v-layout row wrap>
                  <v-flex xs12 sm6 md12>
                    <v-text-field v-model="guncellenecekTedarikci.ad" label="Tedarikçi" :readonly="true""></v-text-field>
                  </v-flex>
                  
                
                   <v-flex xs12 sm6 md6>
                    <v-text-field v-model="guncellenecekTedarikci.username" label="Kullanıcı"></v-text-field>
                  </v-flex>
                    <v-flex xs12 sm6 md6>
                     <v-text-field v-model="guncellenecekTedarikci.password" :label="$t('Password')"></v-text-field>
                  </v-flex>
                   <v-flex xs12 sm6 md12>
                     <v-text-field v-model="guncellenecekTedarikci.securityKey" label="Güvenlik Anahtarı "></v-text-field>
                  </v-flex>
                 </v-layout>
                    <v-layout row wrap>
                       <v-flex xs12 sm12 md12>
                    <v-text-field v-model="guncellenecekTedarikci.url" label="Servis Adresi"></v-text-field>
                  </v-flex>
                 
                     </v-layout>
        </v-card-text>
         <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn color="info" @click="providerGuncelle()"   dark><span
                  class=""> {{ 'Güncelle' }}
                </span>
                       
                      </v-btn>
          <v-btn @click="dialogtedarikciGuncelle = false"  color="info">
            {{$t('Close')}}
          </v-btn>
         
        </v-card-actions>
      </v-card>
     </v-dialog>
    <v-dialog v-model="dialogtedarikci" persi persistent max-width="1200">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text">{{ $t('Supplier') }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          
        <v-form ref="formgunluksatis" lazy-validation>
          <v-card flat class="pa-3">
           
             
                <v-layout row wrap>
                  <v-flex xs12 sm6 md4>
                    <v-select :items="tedarikciItems" v-model="seciliTedarikci" label="Tedarikçi"  item-text="urunAdi" item-value="id" return-object></v-select>
                  </v-flex>
                  
                
                   <v-flex xs12 sm6 md3>
                    <v-text-field v-model="tedarikci.username" label="Kullanıcı"></v-text-field>
                  </v-flex>
                    <v-flex xs12 sm6 md3>
                     <v-text-field v-model="tedarikci.password" :label="$t('Password')"></v-text-field>
                  </v-flex>
                   <v-flex xs12 sm6 md2>
                     <v-text-field v-model="tedarikci.securityKey" label="Güvenlik Anahtarı "></v-text-field>
                  </v-flex>
                 </v-layout>
                    <v-layout row wrap>
                       <v-flex xs12 sm12 md9>
                    <v-text-field v-model="tedarikci.url" label="Servis Adresi"></v-text-field>
                  </v-flex>
                    <v-flex xs12 sm69 md3>
                     <v-btn color="info" @click="providerEkle()"   dark><span
                  class=""> {{ $t('Add') }}
                </span>
                        <v-icon right dark>add_box</v-icon>
                      </v-btn>
                   </v-flex>
                     </v-layout>
                 

               
              
             
          
          </v-card>
        </v-form>
      
           
          <v-container fluid grid-list-sm>
        <v-data-table
          :rows-per-page-items="[100]"
          :headers="headerstedarikci"
          :items="itemsproviders"
        >
          <template slot="items" slot-scope="props">
            <tr item>
              <td class="text-xs-left">
                {{ props.item.Provider }}
              </td>
              <td class="text-xs-left">
                {{ props.item.ServiceUsername }}
              </td>
              <td class="text-xs-left">
                {{ props.item.ServicePassword }}
              </td>
              <td class="text-xs-left">
                {{ props.item.ServiceSecurityKey }}
              </td>
               <td class="text-xs-left">
                {{ props.item.url }}
              </td>
              <td class="text-xs-right">
                <v-btn color="info" @click="providerGuncelleAc(props.item)" fab small>
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
        
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogtedarikci = false" outline color="info">
            {{$t('Close')}}
          </v-btn>
         
        </v-card-actions>
      </v-card>
      </v-dialog>
        <hotelloadingcomp
          ref="hotelloadingcomp"
          iconname="rv_hookup"
          v-bind:mesaj="'Araçlar aranıyor'"
          v-model="loadingdialog"
        ></hotelloadingcomp>

        <v-flex pt-2 xs12 sm12 md12>
          <v-layout row wrap>
            <v-flex xs12 sm3 md3>
              <v-card flat>
                <v-card-actions>
                  <v-layout row wrap class="project overdue">
                    <v-flex xs12 pb-4 pl-2 sm12 md12>
                      <v-form
                        ref="TransferFiyatGetir"
                        v-model="validform"
                        lazy-validation
                      >
                        <v-card flat>
                          <v-layout row wrap>
                            <v-flex pl-1xs12 sm12 md12>
                              <v-autocomplete
                                @change="aramakontrol()"
                                clearable
                                v-model="GetVehicles.PickupPointId"
                                :items="transferaditems"
                                :label="$t('Boarding-Place')"
                                append-icon="search"
                                item-text="name"
                                item-value="value"
                                hide-details
                                :rules="[(v) => !!v || $t('Mandatory-section')]"
                                :search-input.sync="search"
                              >
                                <template slot="item" slot-scope="data">
                                  <span id="PickupName">
                                    {{ data.item.name }}
                                  </span>
                                </template>
                              </v-autocomplete>
                            </v-flex>

                            <v-flex pl-1 pt-2 xs12 sm12 md12>
                              <v-autocomplete
                                :items="transferbirakaditems"
                                @change="aramakontrolBirak()"
                                v-model="GetVehicles.DropPointId"
                                :label="$t('Departure-Place')"
                                item-text="name"
                                item-value="value"
                                append-icon="search"
                                hide-details
                                clearable=""
                                :rules="[(v) => !!v || $t('Mandatory-section')]"
                                :search-input.sync="search2"
                              >
                                <template slot="item" slot-scope="data">
                                  <span id="DropName">
                                    {{ data.item.name }}
                                  </span>
                                </template>
                              </v-autocomplete>
                            </v-flex>

                            <v-flex pl-1 pt-2 xs6 sm4 md6>
                              <tarihim
                                :etiket="$t('Date')"
                                :detaygizle="false"
                                v-model="GetVehicles.TransferDateAndTime"
                                :rules="[(v) => !!v || $t('Mandatory-section')]"
                                v-bind:defaultvalue="'ok'"
                              ></tarihim>
                            </v-flex>

                            <v-flex pl-1 pt-2 xs6 sm4 md6>
                              <v-text-field
                                label="Saat"
                                hide-details
                                :rules="[(v) => !!v || $t('Mandatory-section')]"
                                v-model="Time"
                                type="time"
                              >
                              </v-text-field>
                            </v-flex>

                            <v-flex pl-1 pt-2 xs12 sm4 md4>
                              <v-select
                                :label="$t('Markup-Type')"
                                v-model="GetVehicles.MarkupType"
                                :items="markupitems"
                                item-text="text"
                                item-value="value"
                              >
                              </v-select>
                            </v-flex>

                            <v-flex pl-1 pt-2 xs12 sm4 md4>
                              <!-- <v-text-field label="Markup" v-model="GetVehicles.Markup"
                                                                :rules="[v => !!v || $t('Mandatory-section')]"></v-text-field> -->

                              <parainputevents
                                :rules="[(v) => !!v || $t('Mandatory-section')]"
                                v-if="GetVehicles.MarkupType == 'PC-1'"
                                v-model="GetVehicles.Markup"
                                :simge="getparabirimi()"
                                :etiket="$t('Markup-Amount')"
                                :autocomplete="'autocomplete'"
                              >
                              </parainputevents>

                              <yuzdeinput
                                v-if="GetVehicles.MarkupType == 'PT'"
                                :rules="[(v) => !!v || $t('Mandatory-section')]"
                                :etiket="$t('Markup-Percentage')"
                                v-model="GetVehicles.Markup"
                              >
                              </yuzdeinput>
                            </v-flex>

                            <v-flex pl-1 pt-2 xs12 sm3 md4>
                              <v-select
                                :label="$t('Markup-Unit')"
                                v-model="GetVehicles.MarkupCurrency"
                                :items="kuritems"
                                item-text="text"
                                item-value="value"
                              >
                              </v-select>
                            </v-flex>

                            <v-flex pt-2 xs12 sm12 md12>
                              <v-layout full-width justify-center>
                                <v-menu
                                  bottom
                                  :close-on-content-click="false"
                                  offset-y
                                >
                                  <v-btn outline block slot="activator">
                                    <v-icon color="info"
                                      >supervisor_account
                                    </v-icon>
                                    &nbsp;
                                    <span>
                                      ({{ yetiskinSayi }} {{ $t("Adult") }}
                                      {{ cocukSayi }} {{ $t("Child") }}
                                      {{ bebekSayi }} {{ $t("Baby") }} )</span
                                    >
                                  </v-btn>

                                  <v-list>
                                    <v-list-tile>
                                      <v-list-tile-action>
                                        <v-btn
                                          outline
                                          fab
                                          small
                                          @click="yetiskinAzalt"
                                          :disabled="!!Azalt"
                                          color="primary"
                                        >
                                          <v-icon>remove</v-icon>
                                        </v-btn>
                                      </v-list-tile-action>

                                      <v-list-tile-content>
                                        <v-list-tile-title>
                                          {{ yetiskinSayi }} {{ $t("Adult") }}
                                        </v-list-tile-title>
                                      </v-list-tile-content>

                                      <v-list-tile-action>
                                        <v-btn
                                          outline
                                          fab
                                          small
                                          @click="yetiskinArttir"
                                          color="primary"
                                        >
                                          <v-icon>add_box</v-icon>
                                        </v-btn>
                                      </v-list-tile-action>
                                    </v-list-tile>
                                    <v-list-tile>
                                      <v-list-tile-action>
                                        <v-btn
                                          outline
                                          fab
                                          small
                                          @click="cocukAzalt"
                                          :disabled="!!AzaltCocuk"
                                          color="primary"
                                        >
                                          <v-icon>remove</v-icon>
                                        </v-btn>
                                      </v-list-tile-action>

                                      <v-list-tile-content>
                                        <v-list-tile-title>
                                          {{ cocukSayi }} {{ $t("Child") }}
                                        </v-list-tile-title>
                                      </v-list-tile-content>

                                      <v-list-tile-action>
                                        <v-btn
                                          outline
                                          fab
                                          small
                                          @click="cocukArttir"
                                          color="primary"
                                        >
                                          <v-icon>add_box</v-icon>
                                        </v-btn>
                                      </v-list-tile-action>
                                    </v-list-tile>
                                    <v-list-tile>
                                      <v-list-tile-action>
                                        <v-btn
                                          outline
                                          fab
                                          small
                                          @click="bebekAzalt"
                                          :disabled="!!AzaltBebek"
                                          color="primary"
                                        >
                                          <v-icon>remove</v-icon>
                                        </v-btn>
                                      </v-list-tile-action>

                                      <v-list-tile-content>
                                        <v-list-tile-title
                                          >{{ bebekSayi }}
                                          {{ $t("Baby") }}
                                        </v-list-tile-title>
                                      </v-list-tile-content>

                                      <v-list-tile-action>
                                        <v-btn
                                          outline
                                          fab
                                          small
                                          @click="bebekArttir"
                                          color="primary"
                                        >
                                          <v-icon>add_box</v-icon>
                                        </v-btn>
                                      </v-list-tile-action>
                                    </v-list-tile>
                                  </v-list>
                                </v-menu>
                              </v-layout>
                            </v-flex>

                            <v-flex pt-4 xs12 sm12 md12>
                              <v-btn
                                color="info"
                                outline
                                block
                                @click="TransferAra()"
                              >
                                <span>Transfer Ara</span>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-form>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-flex>
            <!-- v-if="kayitvarmi" -->
            <v-flex xs12  sm12 md9 v-if="kayitvarmi">
              <v-layout row wrap>
                <v-flex xs12 pl-2 sm9 md12>
                  <v-layout row wrap v-show="kayitvarmi">
                    <!-- <v-flex pb-1 pt-1 pr-1 v-for="(item,index) in transferitems" v-bind:key="index"
                                            xs12 sm12 md12>
                                            <v-hover>
                                                <v-card flat="" slot-scope="{ hover }"
                                                    :class="`elevation-${hover ? 12 : 1}`" width="100%">

                                                    <v-list>
                                                        <v-layout row wrap>

                                                            <v-flex pa-1 xs12 sm3 md3>
                                                                <img height="70%" width="90%"
                                                                    src="../../../../assets/images/transfer.png">
                                                            </v-flex>

                                                            <v-flex xs12 sm9 md9>


                                                                <v-list-tile>

                                                                    <v-flex pt-4 xs12 sm12 md12>
                                                                        <v-layout row wrap>
                                                                            <v-flex xs6 sm6 md6>
                                                                                <span class='font-weight-black title'>
                                                                                    {{item.Title}}
                                                                                </span>
                                                                            </v-flex>
                                                                            <v-flex xs6 sm6 md6>
                                                                                <v-layout justify-end>
                                                                                    <span
                                                                                        class="font-weight- title red--text">
                                                                                        {{item.PriceDetails.UserPrice | moneyformat}}
                                                                                        {{item.Rate}}
                                                                                    </span>
                                                                                </v-layout>
                                                                            </v-flex>

                                                                        </v-layout>
                                                                    </v-flex>
                                                                </v-list-tile>


                                                                <v-list-tile>
                                                                    <v-layout row wrap>
                                                                        <v-flex xs12 sm12 pt-2 pb-2 md12>
                                                                            <span
                                                                                class="grey--text font-weight-black mr-1">
                                                                                <v-icon color="grey">alarm</v-icon>
                                                                                &nbsp;
                                                                                {{item.TransferDateAndTime | dateformat}}
                                                                            </span>
                                                                            &nbsp;
                                                                            <span>
                                                                                <v-icon color="grey">
                                                                                    supervisor_account
                                                                                </v-icon>
                                                                                {{item.MaxPax}} {{$t('Passenger')}}
                                                                            </span>
                                                                            &nbsp;
                                                                            <span>
                                                                                <v-icon color="grey">work_outline
                                                                                </v-icon>
                                                                                {{item.MaxSuitcase}}
                                                                            </span>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-list-tile>


                                                                <v-list-tile>

                                                                    <v-layout row wrap>
                                                                        <v-flex pt-4 xs12 sm12 md12>
                                                                            <v-icon color="green">check
                                                                            </v-icon><span class="grey--text"> &nbsp;Son
                                                                                {{ item.FreeCancelHourBefore }} saate
                                                                                kadar
                                                                                iptal
                                                                                hakkı</span>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm12 md12>
                                                                            <v-icon color="green">check
                                                                            </v-icon> <span class="grey--text">&nbsp;Son
                                                                                {{item.FreeChangeHourBefore}} saate
                                                                                kadar
                                                                                değişiklik
                                                                                hakkı</span>
                                                                        </v-flex>
                                                                    </v-layout>

                                                                </v-list-tile>


                                                                <v-list-tile>

                                                                    <v-spacer></v-spacer>
                                                                    <v-btn
                                                                        @click="idgonder(item.VehicleId,item.ResponseId,item.Rate)"
                                                                        color="green">
                                                                        <span class="subtitle-1	 white--text">
                                                                           {{ $t('Select') }}  </span>
                                                                    </v-btn>
                                                                </v-list-tile>


                                                            </v-flex>
                                                        </v-layout>
                                                    </v-list>
                                                </v-card>
                                            </v-hover>
                                        </v-flex> -->

                    <v-flex xs12 sm12 md12>
                      <v-card>
                        <v-list>
                          <v-list-tile>
                            <v-flex xs12 sm10 md10>
                               {{ transferitems.length }}  {{ this.$t('Number-of-Records-Found') }}
                            </v-flex>
                          </v-list-tile>
                        </v-list>
                      </v-card>
                    </v-flex>

                    <v-flex
                      v-for="item in transferitems"
                      v-bind:key="item.Id"
                      xs12
                      sm12
                      md12
                    >
                      <v-hover>
                        <v-card
                          flat=""
                          slot-scope="{ hover }"
                          :class="`elevation-${hover ? 12 : 2}`"
                          width="100%"
                        >
                          <v-list three-line>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-card flat class="black--text">
                                  <v-card flat="">
                                    <v-card-actions>
                                      <v-layout row wrap>
                                        <v-flex sm12 md2>
                                          <v-card flat="">
                                            <v-list-tile>
                                              <v-list-tile-content>
                                                <img
                                                  height="100%"
                                                  width="90%"
                                                  contain
                                                  :src="getImgUrl(item.PhotoPath)"
                                                />
                                              </v-list-tile-content>
                                            </v-list-tile>
                                          </v-card>
                                        </v-flex>

                                        <v-flex xs12 sm4 md5>
                                          <v-layout
                                            align-start
                                            justify-start
                                            row
                                            fill-height
                                          >
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-layout row wrap>
                                                    <v-flex xs12 sm12 md10>
                                                      <span
                                                        class="
                                                          font-weight-black
                                                          subheading
                                                        "
                                                      >
                                                        {{ item.Title }}
                                                      </span>
                                                      <v-icon color="red" small>
                                                        clear
                                                      </v-icon>
                                                      <span
                                                        class="
                                                          font-weight-bold
                                                          red--text
                                                        "
                                                      >
                                                        {{
                                                          item.VehicleCount
                                                        }}</span
                                                      >
                                                    </v-flex>

                                                    <v-flex
                                                      xs12
                                                      sm12
                                                      pt-2
                                                      pb-2
                                                      md12
                                                    >
                                                      <v-layout
                                                        align-center
                                                        fill-height
                                                      >
                                                        <span
                                                          class="
                                                            red--text
                                                            font-weight-
                                                            mr-1
                                                          "
                                                        >
                                                          <v-icon color="grey">
                                                            alarm
                                                          </v-icon>
                                                          &nbsp;
                                                          {{
                                                            item.TransferDateAndTime
                                                              | dateformat
                                                          }}
                                                        </span>
                                                        &nbsp;
                                                        <span>
                                                          <v-icon color="grey">
                                                            people_outline
                                                          </v-icon>
                                                          {{ item.MaxPax }}
                                                          {{ $t("Passenger") }}
                                                        </span>
                                                        &nbsp;
                                                        <span>
                                                          <v-icon color="grey">
                                                            work_outline
                                                          </v-icon>
                                                          {{ item.MaxSuitcase }}
                                                        </span>
                                                      </v-layout>
                                                    </v-flex>
                                                  </v-layout>
                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm4 md3>
                                          <v-layout
                                            align-start
                                            justify-start
                                            row
                                            fill-height
                                          >
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>
                                                      <v-icon
                                                        small
                                                        color="green"
                                                      >
                                                        check
                                                      </v-icon>
                                                      <span
                                                        class="
                                                          grey--text
                                                          body-1
                                                        "
                                                      >
                                                        &nbsp;

                                                        {{
                                                          $t(
                                                            "Cancellation-until-last-hours",
                                                            {
                                                              value:
                                                                item.FreeCancelHourBefore,
                                                            }
                                                          )
                                                        }}
                                                      </span>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                      <v-icon
                                                        small
                                                        color="green"
                                                      >
                                                        check
                                                      </v-icon>
                                                      <span
                                                        class="
                                                          grey--text
                                                          body-1
                                                        "
                                                        >&nbsp;
                                                        {{
                                                          $t(
                                                            "Change-until-hours",
                                                            {
                                                              value:
                                                                item.FreeChangeHourBefore,
                                                            }
                                                          )
                                                        }}
                                                      </span>
                                                    </v-flex>
                                                  </v-layout>
                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm4 md2>
                                          <v-layout
                                            row
                                            align-center
                                            justify-center=""
                                            fill-height=""
                                          >
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-layout
                                                    row
                                                    wrap
                                                    justify-center=""
                                                  >
                                                    <v-list-tile-sub-title>
                                                      <v-layout
                                                        row
                                                        wrap
                                                        justify-center=""
                                                      >
                                                        <div
                                                          pt-2
                                                          class="
                                                            red--text
                                                            title
                                                          "
                                                        >
                                                          {{
                                                            item.PriceDetails
                                                              .UserPrice
                                                              | moneyformat
                                                          }}
                                                          {{ item.Rate }}
                                                        </div>
                                                      </v-layout>
                                                    </v-list-tile-sub-title>
                                                    <v-list-tile-action>
                                                      <v-layout
                                                        row
                                                        align-center=""
                                                        fill-height=""
                                                        justify-center
                                                      >
                                                        <v-btn
                                                          outline
                                                          @click="
                                                            idgonder(
                                                              item.ProductId,
                                                              item.ResponseId,
                                                              item.Rate
                                                            )
                                                          "
                                                          color="green"
                                                        >
                                                          <span
                                                            class="
                                                              subtitle-2
                                                              green--text
                                                            "
                                                          >
                                                            {{ $t("Select") }}
                                                          </span>
                                                        </v-btn>
                                                      </v-layout>
                                                    </v-list-tile-action>
                                                  </v-layout>
                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-actions>
                                  </v-card>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-list>
                        </v-card>
                      </v-hover>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 v-if="!kayitvarmi" sm12 md9 pl-5>
              <v-card>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <blockquote class="blockquote">
                      {{ $t("runner-v8") }}
                      <v-btn
                        color="blue-grey"
                        class="white--text"
                        @click="irtibatDialog()"
                      >
                        {{ $t("CONTACT-US") }}
                        <v-icon right dark>contact_mail</v-icon>
                      </v-btn>
                    </blockquote>
                  </v-flex>

                  <v-flex class="pa-2">
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md12>
                        <img
                          class="responsive"
                          src="../../../../assets/images/paxDrive.jpeg"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

    <v-snackbar
      :timeout="timeout"
      :top="y === 'top'"
      :bottom="y === 'bottom'"
      :right="x === 'right'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      {{ text1 }}
      <v-btn flat color="pink" @click.native="snackbar = false">{{
        $t("Close")
      }}</v-btn>
    </v-snackbar>
    <!--

    Google haritalar açılırsa dialog box'a eklenecek

        <GmapMap v-bind:center="center" :zoom="7" map-type-id="roadmap" style="width: 500px; height: 300px">
       <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :draggable="true" @click="center=m.position" />
        </GmapMap> -->
  </div>
</template>

<script>
import auth from "@/api/auth.js";
import _ from "underscore";
import router from "@/router.js";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import parainputevents from "@/components/app/customcomp/parainputevents";
import yuzdeinput from "@/components/app/customcomp/yuzdeinput";
import hotelloadingcomp from "@/components/app/customcomp/hotelloadingcomp.vue";
import tanitimMail from "@/components/app/customcomp/tanitimMail.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";

//import VueGoogleMaps from "vue2-google-maps"

export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t("Mandatory-Areas"),
      },
        guncellenecekTedarikci:{
          ad:'',
        id:0,
        username:'',
        password:'',
        url:'',
        securityKey:''
       },
       firmaBilgileri:null,
       bookingUserName:'',
       bookingUserPassword:'',
       itemsproviders:[],
       headerstedarikci: [
        {
          text:"Provider",
        },
        {
          text: "Kullanıcı",
        },
        {
          text: "Şifre",
        },
        {
          text: "Güvenlik Anahtarı",
        },
         {
          text: "URL",
        },
         {
          text: "Düzenle",
        },
       
      ],
      tedarikciItems:[
         {
            urunAdi: 'Paxdrive',
            id:0
           
          },
        
      ],
      seciliGuncelleTedarikci:null,
      seciliTedarikci:null,
      tedarikci:{
        ad:'',
        id:0,
        username:'',
        password:'',
        url:'',
        securityKey:''

      },
      dialogtedarikciGuncelle:false,
      dialogtedarikci:false,
      yetkidialog: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      SessionId:'',
      SessionToken:'',
      pagenumber: 1,
      sayfalama: 1,
      paginationDisabled: false,
      vmodelpagination: false,
      islemTipi: null,
      loadingdialog: false,
      validform: true,
      progress: true,
      Time: "",
      search: "",
      search2: "",
      Azalt: false,
      AzaltCocuk: true,
      AzaltBebek: true,
      menu: false,
      yetiskinSayi: 1,
      cocukSayi: 0,
      bebekSayi: 0,
      transferaditems: [],
      transferbirakaditems: [],
      alinisitems: [],
      birakilisitems: [],
      transferitems: [],
      markupitems: [
        {
          text: this.$t("Percentage"),
          value: "PT",
        },
        {
          text: this.$t("Amount"),
          value: "PC-1",
        },
      ],
      GetVehicles: {
        PickupPoint: null,
        DropPoint: null,
        PickupPointId: null,
        DropPointId: null,
        TransferDateAndTime: null,
        AdtPaxCount: null,
        ChdPaxCount: null,
        InfPaxCount: null,
        TransferType: null,
        MarkupType: "PC-1",
        Markup: 0,
        MarkupCurrency: "TRY",
      },
      LocationInput: {
        Text: null,
        Id: 0,
      },
      siralamatipiitems: [
        {
          text: this.$t("Price-Ascending"),
          value: "Price",
        },
        {
          text: this.$t("Price-Descending"),
          value: "PriceDesc",
        },
      ],
      kuritems: [
        {
          text: "TRY",
          vakye: "TRY",
        },
        {
          text: "EUR",
          value: "EUR",
        },
        {
          text: "USD",
          value: "USD",
        },
        {
          text: "GBP",
          value: "GBP",
        },
      ],
      aramaYapildimi: false,
      aramaYapildimiBirak: false,
      kayitvarmi: false,
      kayitsayi: 0,
      clipped: true,
      drawer: true,
      fixed: false,
      right: true,
      dialog: false,
      loginstatus: true,
      drawer: null,
      text1: "",
      snackbar: false,
      loading: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      confirm: null,
      Credential: {
        email: "",
        password: "",
      },
      valid: true,
    };
  },
  props: {
    source: String,
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
   
    if (this.sayfayetki.Status == true) {
      //YETKİ OK
 this.BookingKontrol();
     
      if (
        this.$route.query.islemTipi != undefined &&
        this.$route.query.islemTipi != null
      ) {
        if (this.$route.query.islemTipi == "pdget") {
          this.islemTipi = "pdget";
        } else {
          this.islemTipi = "pdyeni";
        }
      } else {
        this.islemTipi = "pdyeni";
      }

      if (this.islemTipi == "pdget") {
        var pdtransfer = JSON.parse(window.localStorage.getItem("pdtransfer"));

        if (pdtransfer != null) {
          this.yetiskinSayi = 0;
          this.cocukSayi = 0;
          this.bebekSayi = 0;

          pdtransfer.Rezervasyon.adresler.forEach((element) => {
            if (element.kisiTip == 1) {
              this.cocukSayi = this.cocukSayi + 1;
              this.AzaltCocuk = false;
            } else if (element.kisiTip == 2) {
              this.bebekSayi = this.bebekSayi + 1;
              this.AzaltBebek = false;
            } else {
              this.yetiskinSayi = this.yetiskinSayi + 1;
            }
          });
        } else {
          this.text1 = this.$t(
            "Wrong-process-will-conducted-newpnr-record-continue"
          );
          this.snackbar = true;
          this.islemTipi = "pdyeni";
        }
      }
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
  beforeMount: beforeMount,
  methods: {
       providerGuncelleAc(val)
    {
       
      console.log(val);
      this.guncellenecekTedarikci.ad=val.Provider;
      this.guncellenecekTedarikci.id=val.Id;
      this.guncellenecekTedarikci.username=val.ServiceUsername;
      try{
this.guncellenecekTedarikci.url=val.url;
      }catch{

      }
        
       this.guncellenecekTedarikci.password=val.ServicePassword;
        this.guncellenecekTedarikci.securityKey=val.ServiceSecurityKey;
       this.dialogtedarikciGuncelle=true;
    },
    providerGuncelle()
    {
var params = {
  SessionHeader: {
    SessionId: this.SessionId, 
    SessionToken: this.SessionToken},
    Provider:this.guncellenecekTedarikci.ad,
    ProviderType:'Transfer',
    ServiceUsername:this.guncellenecekTedarikci.username,
    ServicePassword:this.guncellenecekTedarikci.password,
    ServiceSecurityKey:this.guncellenecekTedarikci.securityKey,
    Address:this.guncellenecekTedarikci.url
      }
       this.$http
        .post(auth.BOOKING_API_URL + "Agency/EditCredential", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
           console.log(response.body);
            if (response.body.HasError==false)
           {
            this.getProviders();
            this.dialogtedarikciGuncelle=false;
           
           }

          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    providerEkle()
    {
      
var params = {
  SessionHeader: {
    SessionId: this.SessionId, 
    SessionToken: this.SessionToken},
    Provider:this.seciliTedarikci.urunAdi,
    ProviderType:'Transfer',
    ServiceUsername:this.tedarikci.username,
    ServicePassword:this.tedarikci.password,
    ServiceSecurityKey:this.tedarikci.securityKey,
    Address:this.tedarikci.url
      }
       this.$http
        .post(auth.BOOKING_API_URL + "Agency/AddCredential", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
           console.log(response.body);
            if (response.body.HasError==false)
           {
            this.getProviders();
            this.seciliTedarikci==null;
            this.tedarikci.username='';
            this.tedarikci.password='';
            this.tedarikci.securityKey='';
            this.tedarikci.url='';
           }

          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    tedarikcidialogac()
    {
         this.getProviders();
         this.dialogtedarikci=true;
    },
   
    async addAgency2()
    {
      this.loadingvmodel = true;
 var credentials = JSON.parse(window.localStorage.getItem("credentials"));

var params={
  Name:credentials.CoperSirketAdi,
  City:this.firmaBilgileri.City,
  District:this.firmaBilgileri.District,
  CountryCode:"TR",
  Address:this.firmaBilgileri.Address,
  Gsm:this.firmaBilgileri.Gsm,
  Email:this.firmaBilgileri.Email,
  TaxOffice:this.firmaBilgileri.TaxOffice,
  TaxNo:this.firmaBilgileri.TaxNo};

  this.$http
        .post(auth.BOOKING_API_URL + "Agency/AddAgency", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
         (response) => {
          console.log(response);
         if (response.body.Usernanme!=null)
         {
          this.bookingUserName=response.body.Username;
          this.bookingUserPassword=response.body.Password;
         }
            console.log(response);
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
              return false;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
              return false;
            }
          }
        );
       this.loadingvmodel = false;
        return true;
       
    },
async FirmaBilgileriGetir() {
  this.loadingvmodel =true;
  try {
    const credentials = JSON.parse(window.localStorage.getItem("credentials"));
    const paramscompany = {
      SirketKodu: credentials.SirketKodu
    };
    const responsecompany = await this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', paramscompany, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    });

    this.firmaBilgileri = {
      Name: credentials.CoperSirketAdi,
      City: responsecompany.body.Il,
      District: responsecompany.body.Ilce,
      CountryCode: "TR",
      Address: responsecompany.body.Adres,
      Gsm: responsecompany.body.Tel,
      Email: responsecompany.body.Email,
      TaxOffice: responsecompany.body.VergiDairesi,
      TaxNo: responsecompany.body.VergiNo
    };
console.log(this.firmaBilgileri);
    if (!this.firmaBilgileri.Email || !this.firmaBilgileri.TaxNo) {
      this.text1 = "Firma Mail Adresi veya Vergi Numarası Bulunamadı";
      this.loadingvmodel = false;
      this.snackbar = true;
      return false;
    }
    this.loadingvmodel = false;
    return true;
  } catch (error) {
    this.text1 = "Service Unavailable";
    this.loadingvmodel = false;
    this.snackbar = true;
    return false;
  }
},

async EkurunGetir() {
  this.loadingvmodel = true;
  try {
    const params3 = {
      GrupID: null,
      UrunID: null,
      MusteriID: null
    };

    const response = await this.$http.post(auth.API_URL + 'api/Awed/ExtraProductGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    });

    const ekurun = response.body[3].Aktif;

    if (!ekurun) {
      this.text1 = "Pazar Yeri Ürünü Bulunamadı";
      this.loadingvmodel = false;
      this.snackbar = true;
      return false;
    }
this.loadingvmodel = false;
    return true;
  } catch (error) {
    this.text1 = "Service Unavailable";
    this.loadingvmodel = false;
    this.snackbar = true;
    return false;
  }
},

async chkAgency() {
  this.loadingvmodel = true;
  try {
    const params = {
      Email: this.firmaBilgileri.Email,
      TaxNo: this.firmaBilgileri.TaxNo,
    };
    const response = await this.$http.post(auth.BOOKING_API_URL + 'Agency/CheckAgency', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    });
   
    if (response.body.HasError)
    {
      this.loadingvmodel = false;
       return false;
    }
    else
    {
      this.loadingvmodel = false;
          this.bookingUserName=response.body.Username;
          this.bookingUserPassword=response.body.Password;
          return true;
    }
  } catch (error) {
    this.loadingvmodel = false;
    console.log(error);
    return false;
  }
},

async BookingKontrol() {
  const coperFirmaBilgileri = await this.FirmaBilgileriGetir();
  if (!coperFirmaBilgileri) {
    return;
  }

  const ekUrunVar = await this.EkurunGetir();
  if (!ekUrunVar) {
    return;
  }

  
  const firmaVar = await this.chkAgency();
  if (!firmaVar) {
   const firmaEklendi = await this.addAgency2();
  if (!firmaEklendi) {
    return;
  }
  }
  

  if (firmaVar || firmaEklendi)
  {
    await this.login();
  }
  
  
},
    async login()
    {
      
      this.loadingvmodel = true;
      var params = {
        Username: this.bookingUserName,
  Password: this.bookingUserPassword,
  IsTest: true

      };

      this.$http
        .post( auth.BOOKING_API_URL + "Login", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
         
           this.SessionId=response.body.SessionId;
           this.SessionToken=response.body.SessionToken;
           window.localStorage.setItem(
              "transferBookingParams",
              JSON.stringify(response.body)
            );
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
      getProviders()
    {
      this.itemsproviders=[];
 var params = {
  SessionHeader: {
    SessionId: this.SessionId, 
    SessionToken: this.SessionToken}
      }
       this.$http
        .post(auth.BOOKING_API_URL + "Agency/GetCredential", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
          console.log(response.body);
            var rsp=response.body.Credentials;
           rsp.forEach(element => {
            if (element.ProviderType=='Transfer')
           {
 var prv={
      Id:element.Id,
      Provider:element.Provider,
      ProviderType:element.ProviderType,
      ServiceUsername:element.ServiceUsername,
      ServicePassword:element.ServicePassword,
      ServiceSecurityKey:element.ServiceSecurityKey,
      url:element.Address
    }
    this.itemsproviders.push(prv);
           }
   
});
console.log(this.itemsproviders);
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    getImgUrl(pet) {
    return "https://partner.paxdrive.com" + pet;
    
  },
    irtibatDialog() {
      this.$refs.tanitimdialog.open(0);
    },
    getparabirimi() {
      return ""; // helpers.getparabirimi()
    },
    aramakontrol() {
      this.aramaYapildimi = true;
    },
    aramakontrolBirak() {
      this.aramaYapildimiBirak = true;
    },
    yetiskinArttir() {
      this.Azalt = false;
      this.yetiskinSayi++;
    },
    yetiskinAzalt() {
      if (this.yetiskinSayi >= 2) {
        this.yetiskinSayi--;
      } else {
        this.Azalt = true;
      }
    },
    cocukArttir() {
      this.AzaltCocuk = false;
      this.cocukSayi++;
    },
    cocukAzalt() {
      if (this.cocukSayi >= 1) {
        this.cocukSayi--;
      } else {
        this.AzaltCocuk = true;
      }
    },
    bebekArttir() {
      this.AzaltBebek = false;
      this.bebekSayi++;
    },
    bebekAzalt() {
      if (this.bebekSayi >= 1) {
        this.bebekSayi--;
      } else {
        this.AzaltBebek = true;
      }
    },
    idgonder(VehicleId, ResponseId, Rate) {
      var ppi = this.GetVehicles.PickupPointId;
      var dpi = this.GetVehicles.DropPointId;

      var alisyeri = this.transferaditems.filter(function (el) {
        return el.value == ppi;
      });

      var birakilisyeri = this.transferbirakaditems.filter(function (el) {
        return el.value == dpi;
      });

      var PickupText = null;
      var DropText = null;

      if (alisyeri.length > 0) {
        PickupText = alisyeri[0].name;
      } else {
      }

      if (birakilisyeri.length > 0) {
        DropText = birakilisyeri[0].name;
      } else {
      }

      //   var PickupText = alisyeri[0].name // document.getElementById("PickupName").innerText

      //var DropText = document.getElementById("DropName").innerText

      var url =
        "#/coper/paxdrive/transferislem/id?" +
        "vehicleId=" +
        VehicleId +
        "&responseId=" +
        ResponseId +
        "&adultCount=" +
        this.yetiskinSayi +
        "&childCount=" +
        this.cocukSayi +
        "&babyCount=" +
        this.bebekSayi +
        "&dateAndTime=" +
        this.GetVehicles.TransferDateAndTime +
        " " +
        this.Time +
        "&markupCurrency=" +
        Rate +
        "&pickupText=" +
        PickupText +
        "&dropText=" +
        DropText +
        "&pickupPointId=" +
        ppi +
        "&dropPointId=" +
        dpi +
        "&islemTipi=" +
        this.islemTipi;

      window.open(url, "_target");
    },
    AlinisYeriCek: AlinisYeriCek,
    BirakilisYeriCek: BirakilisYeriCek,
    TransferAra: TransferAra,
  },
  components: {
    tarihim,
    parainputevents,
    yuzdeinput,
    hotelloadingcomp,
    tanitimMail,
    yetkidialog,
  },
  watch: {
    search(val) {
      if (this.aramaYapildimi == false) {
        val && this.AlinisYeriCek(val);
      } else {
        this.aramaYapildimi = false;
      }
    },
    search2(val) {
      if (this.aramaYapildimiBirak == false) {
        val && this.BirakilisYeriCek(val);
      } else {
        this.aramaYapildimiBirak = false;
      }
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    timeformat: function (c) {
      return helpers.timeformat(c);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
  },
};

function beforeMount() {}

function AlinisYeriCek(val) {
  if (val.length >= 3) {
    
    this.progress = true;
    var params={
      Location:val,
      SessionHeader:{
        SessionId:this.SessionId,
        SessionToken:this.SessionToken
      }
    
    }
    console.log(params);
    setTimeout(() => {
      this.$http
        .post( auth.BOOKING_API_URL + "Transfer/Location/Search", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.aramaYapildimi = false;
            this.alinisitems = response.body.Locations;

            for (var i = 0; i < this.alinisitems.length; i++) {
              this.transferaditems.push({
                name: this.alinisitems[i].LocName.toLowerCase(),
                value: this.alinisitems[i].LocId,
                deger: this.alinisitems[i].ZoneId,
              });
            }

            this.progress = false;
          
          },
          (response) => {
            this.text1 = this.$t(
              "An-error-has-occurred-during-location-search"
            );
            this.snackbar = false;
            this.progress = false;
          }
        );
    }, 500);
  }
}

function BirakilisYeriCek(val) {
  if (val.length >= 3) {
    this.progress = true;
  

  
    var params={
      Location:val,
      SessionHeader:{
        SessionId:this.SessionId,
        SessionToken:this.SessionToken
      }
    
    }
    setTimeout(() => {
      this.$http
        .post(auth.BOOKING_API_URL + "Transfer/Location/Search", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.aramaYapildimiBirak = false;
            this.birakilisitems = response.body.Locations;

            response.body.Locations.forEach((element) => {
              this.transferbirakaditems.push({
                name: element.LocName,
                value: element.LocId,
                deger: element.ZoneId,
              });
            });

            this.progress = false;

            // if (response.body.HasError.Status == false) {
            //     this.text1 = response.body.HasError.Message
            //     this.snackbar = true
            // }
          },
          (response) => {
            this.text1 = this.$t(
              "An-error-has-occurred-during-location-search"
            );
            this.snackbar = true;
            this.progress = false;
          }
        );
    }, 500);
  }
}

function TransferAra() {
  if (this.$refs.TransferFiyatGetir.validate()) {
    this.odaitems = null;

    this.loadingdialog = true;

    var credentials = JSON.parse(window.localStorage.getItem("credentials"));
    var params={
     
      SessionHeader:{
        SessionId:this.SessionId,
        SessionToken:this.SessionToken
      },
      PickupPoint: null,
      DropPoint: null,
      PickupPointId: this.GetVehicles.PickupPointId,
      DropPointId: this.GetVehicles.DropPointId,
      TransferDateAndTime:
        this.GetVehicles.TransferDateAndTime + " " + this.Time,
      AdtPaxCount: this.yetiskinSayi,
      ChdPaxCount: this.cocukSayi,
      InfPaxCount: this.bebekSayi,
      TransferType: "D",
      MarkupType: this.GetVehicles.MarkupType,
      Markup: this.GetVehicles.Markup,
      // MarkupCurrency: this.GetVehicles.MarkupCurrency,
    }
    // var params = {
    //   LogInput: {
    //     UserID: credentials.UserID,
    //     CustomerID: credentials.MusteriID,
    //   },
    //   PickupPoint: null,
    //   DropPoint: null,
    //   PickupPointId: this.GetVehicles.PickupPointId,
    //   DropPointId: this.GetVehicles.DropPointId,
    //   TransferDateAndTime:
    //     this.GetVehicles.TransferDateAndTime + " " + this.Time,
    //   AdtPaxCount: this.yetiskinSayi,
    //   ChdPaxCount: this.cocukSayi,
    //   InfPaxCount: this.bebekSayi,
    //   TransferType: "D",
    //   MarkupType: this.GetVehicles.MarkupType,
    //   Markup: this.GetVehicles.Markup,
    //   MarkupCurrency: this.GetVehicles.MarkupCurrency,
    // };

    this.$http
      .post(auth.BOOKING_API_URL + "transfer/Search", params, {
        headers: {
          Authorization:
            "Basic " +
            window.btoa(
              auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
            ),
        },
      })
      .then(
        (response) => {
          this.transferitems = response.body.Vehicles;
          this.kayitvarmi = true;
          this.loadingdialog = false;
console.log(this.transferitems)
          // if (response.body.HasError.Status == true) {
          //     this.text1 = response.body.HasError.Message
          //     this.snackbar = true
          // }
        },
        (response) => {
          this.text1 = this.$t(
            "An-error-has-occurred-while-searching-transfer"
          );
          this.snackbar = true;
          this.loadingdialog = false;
        }
      );
  } else {
    this.text1 = this.$t('Please-fill-in-the-required-fields.');
    this.snackbar = true;
  }
}
</script>

<style scoped>
.responsive {
  max-width: 100%;
  height: auto;
}
</style>